import Moment from "moment";
import {
  addEvents,
  deleteEvent,
  editEvent,
} from "../features/personalDatabaseSlice";

import { generateEventId } from "../utils/data/events";

export const monthMarkerEventsTask = function (store) {
  const state = store.getState();

  if (!state.personalDatabase.contents) {
    console.log("Database not ready");
    return;
  }
  const events = state.personalDatabase.contents.events;
  const dob = state.personalDatabase.contents.metadata.dateOfBirth;
  const dobMom = Moment(dob);

  console.log("tock tick", state);

  const endYear = Moment(events[events.length - 1].datetime).year();

  let firstEventDatetime = dobMom;
  if (events.length > 0 && Moment(events[0].datetime) < dobMom) {
    firstEventDatetime = Moment(events[0].datetime);
  }

  const startYear = Moment(firstEventDatetime).year();

  // run through all years

  if (startYear > endYear) {
    throw new Error("Invalid start/end year combination");
  }

  const yearsMonthsWithMarkerEvents = [];

  const toDeleteIds = [];
  events.forEach((event) => {
    // only process bday events
    if (event.eventType !== "EventGeneralMonthMarker") {
      return;
    }
    // check if the year is correct

    const eventDatetime = Moment(event.datetime);
    const eventYearMonthMarker = eventDatetime.format("YYYY-MM");

    if (yearsMonthsWithMarkerEvents.includes(eventYearMonthMarker)) {
      // we should not be seeing bday event twice - delete
      toDeleteIds.push(event.id);
    } else {
      // mark as seen
      yearsMonthsWithMarkerEvents.push(eventYearMonthMarker);
    }
  });

  // delete duplicate even markers events
  toDeleteIds.forEach((toDeleteId) => {
    store.dispatch(
      deleteEvent({
        id: toDeleteId,
      })
    );
  });

  const toAddEvents = [];

  // now, populate any missing month markers!
  for (var year = startYear; year <= endYear; year++) {
    for (var month = 0; month < 12; month++) {
      if (year === startYear && month < firstEventDatetime.month()) {
        // no markers before first event
        continue;
      }
      const markerDatetime = Moment();
      markerDatetime.utcOffset(0);
      markerDatetime.year(year);
      markerDatetime.month(month);
      markerDatetime.date(1);
      markerDatetime.hours(0);
      markerDatetime.minutes(0);
      markerDatetime.seconds(0);
      markerDatetime.millisecond(0);
      if (
        yearsMonthsWithMarkerEvents.includes(markerDatetime.format("YYYY-MM"))
      ) {
        continue;
      }

      // generate event
      const markerEvent = {
        name: `Marker event for ${markerDatetime.format("YYYY-MM")}`,
        description: `Marking ${markerDatetime.format("YYYY-MM")}`,
        displayTimezone: "",
        categoryId: 0, // zero for auto-generated events
        datetime: markerDatetime.toISOString(),
        datetimeEnd: "",
        attachments: [],
        tags: [],
      };

      markerEvent.id = generateEventId(markerEvent);
      console.log(markerEvent);

      toAddEvents.push({
        eventType: "EventGeneralMonthMarker",
        item: markerEvent,
      });
    }
  }
  if (toAddEvents.length > 0) {
    store.dispatch(
      addEvents({
        itemsAndTypes: toAddEvents,
      })
    );
  }
};
